import { jsx } from "react/jsx-runtime";
import API, { createMAX, handlePermissionsUpdate, getAuthInfo } from "@zillow/mortgage-api-client";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useLocallyStoredObject, useStoreValidFieldsLocally } from "../../utils/form/persist-hooks.esm.js";
function CalculatorForm(props) {
  const [persistedDefaultValuesDisabled, setPersistedDefaultValuesDisabled] = useState(true);
  useEffect(function enablePersistedDefaultValuesAfterInitialRenderInBrowser() {
    setPersistedDefaultValuesDisabled(false);
  }, []);
  return /* @__PURE__ */ jsx(LoadedCalculatorForm, { persistedDefaultValuesDisabled, ...props }, persistedDefaultValuesDisabled.toString());
}
function LoadedCalculatorForm({
  persistedDefaultValuesDisabled,
  calcTypeForMarketing,
  children,
  className,
  defaultValues,
  fieldStorageKey,
  editorMode,
  onSubmit
}) {
  const form = useForm({
    mode: "onTouched",
    defaultValues: useLocallyStoredObject(fieldStorageKey, defaultValues, {
      disablePersistance: persistedDefaultValuesDisabled || editorMode
    })
  });
  useStoreValidFieldsLocally(fieldStorageKey, form, {
    disablePersistance: editorMode
  });
  useEffect(() => {
    if (!calcTypeForMarketing) {
      return;
    }
    const {
      unsubscribe
    } = form.watch(() => {
      triggerMarketing(calcTypeForMarketing);
      unsubscribe();
    });
    return () => {
      unsubscribe();
    };
  }, []);
  return /* @__PURE__ */ jsx("form", { className, onSubmit: form.handleSubmit(onSubmit || Function.prototype), children: /* @__PURE__ */ jsx(FormProvider, { ...form, children }) });
}
async function triggerMarketing(calcTypeForMarketing) {
  if (!API.MAX) {
    if (!window._zconfig.serverURLs.MAX) {
      throw new Error("MAX serverURL is not set");
    }
    createMAX(window._zconfig.serverURLs.MAX);
  }
  await handlePermissionsUpdate(await getAuthInfo());
  if (!API.user) {
    return;
  }
  await API.MAX.POST({
    action: "initiateCalculatorFollowupForUser",
    includeAuth: true,
    // IMPORTANT!
    authentication: "error",
    input: {
      calculatorType: calcTypeForMarketing
    }
  });
}
CalculatorForm.defaultProps = {
  children: void 0,
  className: void 0,
  defaultValues: void 0,
  editorMode: false,
  calcTypeForMarketing: void 0
};
CalculatorForm.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  editorMode: PropTypes.bool,
  fieldStorageKey: PropTypes.string.isRequired,
  defaultValues: PropTypes.shape({}),
  calcTypeForMarketing: PropTypes.string,
  onSubmit: PropTypes.func
};
export {
  CalculatorForm as default
};
